// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Shared internals for the four pages that render inside AuthSplitLayout.
 */

.authForm_pane__in\\+5T {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

/* Heading */
.authForm_head__AbXLJ {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.authForm_title__LMyTA {
  font-size: clamp(1.4rem, 1.2rem + 0.62vw, 1.7rem);
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.022em;
  color: var(--text-primary);
}

.authForm_lead__8aUqd {
  font-size: 0.9375rem;
  line-height: 1.55;
  color: var(--text-secondary);
  max-width: 46ch;
}

/* Form */
.authForm_form__Wv65E {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.authForm_submit__woMXb {
  margin-top: var(--space-1);
}

.authForm_secretField__ZHEQX {
  position: relative;
  display: flex;
  align-items: center;
}

.authForm_secretField__ZHEQX .authForm_secretInput__UOXZU {
  padding-right: 68px;
}

.authForm_reveal__Z9YUT {
  position: absolute;
  right: 5px;
  padding: 5px 9px;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-secondary);
  font-family: var(--font);
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1.4;
  cursor: pointer;
  transition:
    background-color var(--dur-fast) var(--ease-standard),
    color var(--dur-fast) var(--ease-standard);
}

.authForm_reveal__Z9YUT:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

/* Links */
.authForm_links__pdiyB {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding-top: var(--space-5);
  border-top: 1px solid var(--border-light);
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--text-secondary);
}

/* Stepper */
.authForm_stepper__h7NP1 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-4);
  list-style: none;
  margin: 0;
  padding: 0;
}

.authForm_step__kXAg7 {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding-top: var(--space-2);
  border-top: 2px solid var(--border);
  color: var(--text-secondary);
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.4;
}

.authForm_stepCurrent__VIAYi,
.authForm_stepDone__V3WTO {
  border-top-color: var(--primary);
  color: var(--primary-dark);
}

.authForm_stepDot__uaV57 {
  display: inline-grid;
  place-items: center;
  flex: none;
  width: 20px;
  height: 20px;
  border-radius: var(--radius-full);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 0.6875rem;
  font-weight: 700;
}

.authForm_stepCurrent__VIAYi .authForm_stepDot__uaV57,
.authForm_stepDone__V3WTO .authForm_stepDot__uaV57 {
  background: var(--primary);
  color: var(--text-on-primary);
}

.authForm_stepDone__V3WTO .authForm_stepDot__uaV57 svg {
  width: 12px;
  height: 12px;
}

.authForm_stepLabel__Dpt-- {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Fieldset */
.authForm_fieldset__kT8nP {
  margin: 0;
  padding: 0;
  border: 0;
  min-width: 0;
}

.authForm_legend__iaeIx {
  padding: 0;
  margin-bottom: var(--space-2);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.45;
  color: var(--text-primary);
}

/* Role choice */
.authForm_choices__ZAA9R {
  display: grid;
  gap: var(--space-2);
}

.authForm_choice__KisDi {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: 10px 12px;
  border: 1px solid var(--border-dark);
  border-radius: var(--radius-input);
  background: var(--bg);
  color: var(--text-primary);
  font-size: 0.9375rem;
  line-height: 1.45;
  cursor: pointer;
  transition:
    border-color var(--dur-fast) var(--ease-standard),
    background-color var(--dur-fast) var(--ease-standard);
}

.authForm_choice__KisDi:hover {
  border-color: var(--primary);
}

.authForm_choice__KisDi input {
  accent-color: var(--primary);
  margin: 0;
}

.authForm_choice__KisDi:has(input:checked) {
  border-color: var(--primary);
  background: var(--surface-brand-wash);
  font-weight: 600;
}

.authForm_choice__KisDi:has(input:focus-visible) {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

/* Verify code */
input.authForm_code__MAZ2W {
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: 0.32em;
  text-align: center;
}

input.authForm_code__MAZ2W::placeholder {
  letter-spacing: 0.32em;
  font-weight: 400;
}

@media (max-width: 480px) {
  .authForm_pane__in\\+5T {
    gap: var(--space-5);
  }

  .authForm_title__LMyTA {
    font-size: 1.3rem;
  }

  .authForm_lead__8aUqd {
    font-size: 0.875rem;
  }

  .authForm_form__Wv65E {
    gap: var(--space-4);
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/authForm.module.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf;;8CAE4C;AAC9C;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;EACzC,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,YAAY;AACd;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,kCAAkC;EAClC,qBAAqB;EACrB,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf;;yDAEuD;AACzD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/*\n * Shared internals for the four pages that render inside AuthSplitLayout.\n */\n\n.pane {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6);\n}\n\n/* Heading */\n.head {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n}\n\n.title {\n  font-size: clamp(1.4rem, 1.2rem + 0.62vw, 1.7rem);\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.022em;\n  color: var(--text-primary);\n}\n\n.lead {\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n  max-width: 46ch;\n}\n\n/* Form */\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-5);\n}\n\n.submit {\n  margin-top: var(--space-1);\n}\n\n.secretField {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.secretField .secretInput {\n  padding-right: 68px;\n}\n\n.reveal {\n  position: absolute;\n  right: 5px;\n  padding: 5px 9px;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--text-secondary);\n  font-family: var(--font);\n  font-size: 0.8125rem;\n  font-weight: 700;\n  line-height: 1.4;\n  cursor: pointer;\n  transition:\n    background-color var(--dur-fast) var(--ease-standard),\n    color var(--dur-fast) var(--ease-standard);\n}\n\n.reveal:hover {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n/* Links */\n.links {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  padding-top: var(--space-5);\n  border-top: 1px solid var(--border-light);\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n/* Stepper */\n.stepper {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-4);\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.step {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding-top: var(--space-2);\n  border-top: 2px solid var(--border);\n  color: var(--text-secondary);\n  font-size: 0.8125rem;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.stepCurrent,\n.stepDone {\n  border-top-color: var(--primary);\n  color: var(--primary-dark);\n}\n\n.stepDot {\n  display: inline-grid;\n  place-items: center;\n  flex: none;\n  width: 20px;\n  height: 20px;\n  border-radius: var(--radius-full);\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  font-size: 0.6875rem;\n  font-weight: 700;\n}\n\n.stepCurrent .stepDot,\n.stepDone .stepDot {\n  background: var(--primary);\n  color: var(--text-on-primary);\n}\n\n.stepDone .stepDot svg {\n  width: 12px;\n  height: 12px;\n}\n\n.stepLabel {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Fieldset */\n.fieldset {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  min-width: 0;\n}\n\n.legend {\n  padding: 0;\n  margin-bottom: var(--space-2);\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.45;\n  color: var(--text-primary);\n}\n\n/* Role choice */\n.choices {\n  display: grid;\n  gap: var(--space-2);\n}\n\n.choice {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  padding: 10px 12px;\n  border: 1px solid var(--border-dark);\n  border-radius: var(--radius-input);\n  background: var(--bg);\n  color: var(--text-primary);\n  font-size: 0.9375rem;\n  line-height: 1.45;\n  cursor: pointer;\n  transition:\n    border-color var(--dur-fast) var(--ease-standard),\n    background-color var(--dur-fast) var(--ease-standard);\n}\n\n.choice:hover {\n  border-color: var(--primary);\n}\n\n.choice input {\n  accent-color: var(--primary);\n  margin: 0;\n}\n\n.choice:has(input:checked) {\n  border-color: var(--primary);\n  background: var(--surface-brand-wash);\n  font-weight: 600;\n}\n\n.choice:has(input:focus-visible) {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n/* Verify code */\ninput.code {\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: 0.32em;\n  text-align: center;\n}\n\ninput.code::placeholder {\n  letter-spacing: 0.32em;\n  font-weight: 400;\n}\n\n@media (max-width: 480px) {\n  .pane {\n    gap: var(--space-5);\n  }\n\n  .title {\n    font-size: 1.3rem;\n  }\n\n  .lead {\n    font-size: 0.875rem;\n  }\n\n  .form {\n    gap: var(--space-4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pane": `authForm_pane__in+5T`,
	"head": `authForm_head__AbXLJ`,
	"title": `authForm_title__LMyTA`,
	"lead": `authForm_lead__8aUqd`,
	"form": `authForm_form__Wv65E`,
	"submit": `authForm_submit__woMXb`,
	"secretField": `authForm_secretField__ZHEQX`,
	"secretInput": `authForm_secretInput__UOXZU`,
	"reveal": `authForm_reveal__Z9YUT`,
	"links": `authForm_links__pdiyB`,
	"stepper": `authForm_stepper__h7NP1`,
	"step": `authForm_step__kXAg7`,
	"stepCurrent": `authForm_stepCurrent__VIAYi`,
	"stepDone": `authForm_stepDone__V3WTO`,
	"stepDot": `authForm_stepDot__uaV57`,
	"stepLabel": `authForm_stepLabel__Dpt--`,
	"fieldset": `authForm_fieldset__kT8nP`,
	"legend": `authForm_legend__iaeIx`,
	"choices": `authForm_choices__ZAA9R`,
	"choice": `authForm_choice__KisDi`,
	"code": `authForm_code__MAZ2W`
};
export default ___CSS_LOADER_EXPORT___;
